export const DialogGroups = {
  crm: {
    activities: {
      confirmDeleteActivity: 'crm:activities:confirm-delete',
    },
  },
};
